module.exports = __webpack_public_path__ + "static/media/honeycomb-logo-small.bda6a16a.png";